import { useEffect, useRef, useState } from 'react';
import {
  DEFAULT_FULL_SCREEN_PAYWALL_ENABLED,
  getFullScreenPaywallEnabled,
} from '@/features/subscription/remote-config/fullScreenPaywall';

const RESOLVE_TIMEOUT_MS = 1_500;

export const useFullScreenPaywallEnabled = () => {
  const [isEnabled, setIsEnabled] = useState<boolean | null>(null);
  const isSettledRef = useRef(false);

  useEffect(() => {
    isSettledRef.current = false;

    const settle = (value: boolean) => {
      if (isSettledRef.current) return;
      isSettledRef.current = true;
      setIsEnabled(value);
    };

    const timer = setTimeout(
      () => settle(DEFAULT_FULL_SCREEN_PAYWALL_ENABLED),
      RESOLVE_TIMEOUT_MS
    );

    void getFullScreenPaywallEnabled()
      .then((value) => {
        clearTimeout(timer);
        settle(value);
      })
      .catch(() => {
        clearTimeout(timer);
        settle(DEFAULT_FULL_SCREEN_PAYWALL_ENABLED);
      });

    return () => {
      isSettledRef.current = true;
      clearTimeout(timer);
    };
  }, []);

  return isEnabled;
};
